import {
	type AppUpdateCheckOut,
	updateCheckApiV1AppUpdateCheckGet,
} from "@/shared/api/generated-backend"
import { env } from "@/shared/config/env"

export function fetchUpdateCheck(): Promise<AppUpdateCheckOut> {
	const headers: Record<string, string> = {}
	if (env.VITE_PUBLIC_APP_VERSION) {
		headers["X-Webapp-Version"] = env.VITE_PUBLIC_APP_VERSION
	}
	return updateCheckApiV1AppUpdateCheckGet({ headers })
}
